import { useTheme } from '@playbooks/contexts';
import { Icon } from '@playbooks/ui/components/icon';
import { ToggleGroup, ToggleGroupItem } from '@playbooks/ui/components/toggle-group';
import { cn } from '@playbooks/ui/lib/utils';

const AppThemeToggle = ({ compact = false }) => {
	const theme = useTheme();

	// Theme
	const classNames = {
		root: cn(compact ? 'w-auto gap-0.5' : 'w-full lg:w-auto'),
		item: cn(compact ? 'size-7 flex-none px-0' : 'w-full'),
	};

	// Render
	return (
		<ToggleGroup
			value={theme.loaded ? [theme.preference] : []}
			onValueChange={values => {
				const preference = values[0];
				if (preference === 'light' || preference === 'dark' || preference === 'system') {
					theme.setPreference(preference);
				}
			}}
			className={classNames.root}>
			<ToggleGroupItem value='light' aria-label='light' className={classNames.item}>
				<Icon data-icon='inline-start' type='fad' icon='sun-bright' aria-hidden />
			</ToggleGroupItem>
			<ToggleGroupItem value='dark' aria-label='dark' className={classNames.item}>
				<Icon data-icon='inline-start' type='fad' icon='moon' aria-hidden />
			</ToggleGroupItem>
			<ToggleGroupItem value='system' aria-label='system' className={classNames.item}>
				<Icon data-icon='inline-start' type='fad' icon='desktop' aria-hidden />
			</ToggleGroupItem>
		</ToggleGroup>
	);
};

export { AppThemeToggle };
